/**
 * String utility functions for handling text processing
 */

/**
 * Decode HTML entities from a string
 * @param {string} text - Text with HTML entities
 * @returns {string} Decoded text
 */
export const decodeHtmlEntities = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  
  // Create a temporary element to decode HTML entities
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
};

/**
 * Ensure a value is a string before string operations
 * @param {any} value - Value to convert to string
 * @returns {string} String representation
 */
export const ensureString = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
};

/**
 * Safe replace function that ensures the input is a string
 * @param {any} value - Value to perform replace on
 * @param {RegExp|string} searchValue - Value to search for
 * @param {string} replaceValue - Value to replace with
 * @returns {string} String with replacements made
 */
export const safeReplace = (value, searchValue, replaceValue) => {
  const stringValue = ensureString(value);
  return stringValue.replace(searchValue, replaceValue);
};

/**
 * Clean and normalize income name by decoding HTML entities
 * @param {string} name - Income name that may have HTML entities
 * @returns {string} Clean, readable name
 */
export const cleanIncomeName = (name) => {
  if (!name) return '';
  
  const decodedName = decodeHtmlEntities(name);
  return decodedName.trim();
}; 